import axios from 'axios'
import {
  API_SC_ORIGIN,
  API_SC_SUBSCRIPTION_KEY,
  API_PRODUCTS_REFRESH_TEMPLATE,
} from 'constants/urls'
import React, { useEffect } from 'react'
import { encryptAES256CBC, decryptAES256CBC } from 'utils/encryptData'
import useStyles from './styles'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'
import { routeBase } from 'constants/environments.constants'
import { CloudDownloadIcon } from 'components/icons/personalizedIcons'

const BLOB_TEMPLATE_BASE =
  routeBase[process.env.REACT_APP_ENVIRONMENT].blobTemplateBase ||
  'https://luegopago.blob.core.windows.net/luegopago-uploads-private'

const RefreshTemplate = () => {
  const searchParams = new URLSearchParams(window.location.search)
  const classes = useStyles()
  const history = useHistory()

  const [newUrl, setNewUrl] = React.useState(null)

  const downloadFile = async () => {
    const baseUrl = BLOB_TEMPLATE_BASE
    const buildedUrl = new URL(baseUrl)

    const sourcePath = searchParams.get('source')

    if (sourcePath) {
      const tempUrl = new URL(sourcePath, 'https://dummy')

      const basePath = buildedUrl.pathname.replace(/\/$/, '')
      const sourceFilePath = tempUrl.pathname.replace(/^\//, '')

      buildedUrl.pathname = `${basePath}/${sourceFilePath}`

      tempUrl.searchParams.forEach((value, key) => {
        buildedUrl.searchParams.append(key, value)
      })
    }

    searchParams.forEach((value, key) => {
      if (key !== 'source') {
        buildedUrl.searchParams.append(key, value)
      }
    })

    try {
      const response = await axios.get(buildedUrl.toString())
      const downloadableUrl = buildedUrl.toString()
      if (response.status === 200) {
        setNewUrl(downloadableUrl)
        const anchor = document.createElement('a')
        anchor.href = downloadableUrl
        anchor.setAttribute('download', 'Productos.xlsx')
        document.body.appendChild(anchor)
        anchor.click()
        document.body.removeChild(anchor)
      }
    } catch (error) {
      if (error.response.status === 403) {
        const newResponse = await axios.post(
          API_PRODUCTS_REFRESH_TEMPLATE,
          encryptAES256CBC(JSON.stringify({ url: buildedUrl.toString() })),
          {
            headers: {
              'Content-Type': 'text/plain',
              SCOrigen: API_SC_ORIGIN,
              'Ocp-Apim-Subscription-Key': API_SC_SUBSCRIPTION_KEY,
            },
          }
        )
        if (newResponse.status === 200) {
          const downloadableUrl = JSON.parse(decryptAES256CBC(newResponse.data)).url

          try {
            const retryResponse = await axios.get(downloadableUrl)
            if (retryResponse.status === 200) {
              setNewUrl(downloadableUrl)
              const anchor = document.createElement('a')
              anchor.href = downloadableUrl
              anchor.setAttribute('download', 'Productos.xlsx')
              document.body.appendChild(anchor)
              anchor.click()
              document.body.removeChild(anchor)
            }
          } catch (retryError) {
            console.error('Failed to download file with new SAS URL:', retryError)
          }
        }
      }
    }
  }

  const onClickDownload = () => {
    if (newUrl) {
      const anchor = document.createElement('a')
      anchor.href = newUrl
      anchor.setAttribute('download', 'Productos.xlsx')
      document.body.appendChild(anchor)
      anchor.click()
      document.body.removeChild(anchor)
    } else {
      downloadFile()
    }
  }

  useEffect(() => {
    downloadFile()
  }, [])

  return (
    <div className={classes.container}>
      <img
        src="https://stoconopmercurio.blob.core.windows.net/assets/images/loading-sistecredito.gif"
        alt="loading"
        style={{ margin: '0 auto' }}
        width={145}
        height={145}
      />
      <h1 className={classes.title}>Tu archivo se descargará en unos segundos.</h1>
      <h2 className={classes.subTitle}>Si no inicia, haz clic en “Descargar archivo”.</h2>
      <div className={classes.actionsContainer}>
        <button className={classes.sisteButtonFilled} onClick={onClickDownload} disabled={!newUrl}>
          <div className={classes.buttonContent}>
            <CloudDownloadIcon /> <span>Descargar archivo</span>
          </div>
        </button>
      </div>
      <span className={classes.spanHelperText}>
        Si se realizó la descarga, puedes cerrar esta ventana.
      </span>
    </div>
  )
}

export default RefreshTemplate
